export default __webpack_public_path__ + "static/media/contentbook.da0d3030.svg";